import { Divider } from "@mui/material";
import { Box } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../store/types";
import SbuxSelect from "../../SbuxSelect";
import { getLocale } from "../../../services/settings";
import languageConfig from "../config/language.json";
import { getLocaleSelector } from "../../../selectors/settingsSelector";
import SbuxTranslate from "../../SbuxTranslate";

const LanguageList = () => {
  const dispatch = useAppDispatch();

  const locale = useAppSelector(getLocaleSelector);

  const handleChange = async (value: string) => {
    await dispatch(getLocale(value));
  };

  const menuItems = languageConfig.lanaguages.map((item) => {
    return {
      name: item.language,
      value: item.code,
    };
  });

  return (
    <Box
      sx={{
        paddingLeft: 2,
        paddingTop: 0.5,
        paddingBottom: 0.5,
        paddingRight: 1,
      }}
    >
      <Box>
        <SbuxSelect
          label={<SbuxTranslate>{"Language"}</SbuxTranslate>}
          menuItems={menuItems}
          defaultValue={locale}
          value={locale}
          handleSelectChange={handleChange}
        />
      </Box>

      <Divider sx={{ marginTop: 1 }} />
    </Box>
  );
};

export default LanguageList;
